// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3Ubl1","boxWrapper":"_3eWX2"};